import { DataManager } from '@syncfusion/ej2-data';
import { HistoryService } from './history.service';
import { Component, OnInit } from '@angular/core';
import { ClientDTO, ExportInterfaceConfigurationType } from 'src/app/base/models/models.swagger.generated';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ClientAutocompleteComponent } from '../../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    imports: [TitleBarComponent, ClientAutocompleteComponent, GridModule, QueryBuilderModule, TranslateModule]
})
export class HistoryComponent extends GridBaseComponent<any> implements OnInit {

  public get selectedClient(): ClientDTO {
    return this.historyService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.historyService.selectedClient != value) {
      this.historyService.selectedClient = value;
      this.grid.refresh();
    }
  }

  public successFilter = GridConstantsFactory.createCheckBoxFilter();

  constructor(
    private historyService: HistoryService,
    translateService: TranslateService
  ) {
    super(translateService, historyService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.historyService, null),
    });
  }

  public getTypeName(type: number): string {
    return 'i18n.shared.configurationTypes.' + ExportInterfaceConfigurationType[type];
  }

  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

}
